// Shared helpers for the approval-email recipient pickers (PR / EA / DC).
//
// buildMemberOptions turns a list of workspace members (or any people-shaped
// objects) into react-select options of the form { label, value }, where the
// value is the email (the submit payload remains a flat array of email strings).
//
// buildLockedRecipients turns the auto-included people (requestor + chain
// approvers) into DISPLAY-ONLY chip descriptors. These are never added to the
// submit payload — the server force-includes them.

const fullName = (person) => (person?.name || `${person?.first_name || ''} ${person?.last_name || ''}`).trim();

const personLabel = (person) => {
    const name = fullName(person);
    if (name && person?.email) {
        return `${name} <${person.email}>`;
    }
    return name || person?.email || '';
};

export const buildMemberOptions = (members) =>
    (members || []).filter((member) => member && member.email).map((member) => ({ label: personLabel(member) || member.email, value: member.email }));

// Build the locked, non-removable chip descriptors for the auto-included people.
// `requestor` is a single person (or null); `approvers` is a list of people.
// Each chip is { label, role } where role is the translated suffix shown in brackets.
export const buildLockedRecipients = ({ requestor, requestorRole, approvers, approverRole } = {}) => {
    const chips = [];

    if (requestor) {
        const label = fullName(requestor) || requestor.email;
        if (label) {
            chips.push({ label, role: requestorRole });
        }
    }

    (approvers || []).forEach((approver) => {
        const label = fullName(approver) || approver?.email;
        if (label) {
            chips.push({ label, role: approverRole });
        }
    });

    return chips;
};
